import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=06781112&scoped=true&"
import script from "./GroupView.vue?vue&type=script&lang=js&"
export * from "./GroupView.vue?vue&type=script&lang=js&"
import style0 from "./minds.css?vue&type=style&index=0&lang=css&"
import style1 from "./GroupView.vue?vue&type=style&index=1&id=06781112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06781112",
  null
  
)

export default component.exports